import { render, staticRenderFns } from "./HandleMoreSubscriptions.vue?vue&type=template&id=77da653c&scoped=true&"
import script from "./HandleMoreSubscriptions.vue?vue&type=script&lang=js&"
export * from "./HandleMoreSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./HandleMoreSubscriptions.vue?vue&type=style&index=0&id=77da653c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da653c",
  null
  
)

export default component.exports